import styled from '@emotion/styled';
import type { RacemapEvent } from '@racemap/utilities/types/events';
import { Checkbox, Form } from 'antd';
import type { Immutable } from 'immer';
import type { FC } from 'react';
import { IconSetting } from '../Icon';
import { BasicModal } from './BasicModal';

interface Props {
  event: Immutable<RacemapEvent>;
  showStartTime: boolean;
  showDeltaTime: boolean;
  showOnline: boolean;
  onShowStartTimeChange: (arg0: boolean) => void;
  onShowDeltaTimeChange: (arg0: boolean) => void;
  onShowOnlineChange: (arg0: boolean) => void;
}

export const SettingsModal: FC<Props> = ({
  event,
  showStartTime,
  showDeltaTime,
  showOnline,
  onShowStartTimeChange,
  onShowDeltaTimeChange,
  onShowOnlineChange,
}) => {
  const netReplay = event.modules.netReplay.enabled;
  const visibleElements = event.modules.timing.visibleElements;
  const eventIsRunning = new Date(event.endTime).getTime() - Date.now() > 0;

  return (
    <BasicModal title="Settings:" buttonIcon={<IconSetting fixedWidth />}>
      <Form
        initialValues={{
          startTime: showStartTime,
          deltaTimes: showDeltaTime,
          onlineParticipants: showOnline,
        }}
        onValuesChange={(_, values) => {
          onShowStartTimeChange(!!values.startTime);
          onShowDeltaTimeChange(!!values.deltaTimes);
          onShowOnlineChange(!!values.onlineParticipants);
        }}
      >
        <CheckboxGroup>
          {visibleElements.stages && !netReplay && (
            <Form.Item name="startTime" valuePropName="checked">
              <Checkbox>Show Start Times</Checkbox>
            </Form.Item>
          )}
          {visibleElements.stages && (
            <Form.Item name="deltaTimes" valuePropName="checked">
              <Checkbox>Show Delta Times</Checkbox>
            </Form.Item>
          )}
          {eventIsRunning && (
            <Form.Item name="onlineParticipants" valuePropName="checked">
              <Checkbox>Filter Online Participants</Checkbox>
            </Form.Item>
          )}
        </CheckboxGroup>
      </Form>
    </BasicModal>
  );
};

const CheckboxGroup = styled.div`
  .ant-form-item {
    margin-bottom: unset;
  }
`;
